import styled from 'styled-components'

import Grid from '@material-ui/core/Grid'

export const PlotsList = styled(Grid)`
  padding: 15px 0;
  max-height: 50vh;
  overflow: auto;
`